import { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { ActionBarContent } from './ActionBarContent';
import { ActionBarHeader } from './ActionBarHeader';

interface ActionBarProps {
  readonly children: ReactNode;
  readonly className?: string;
}

function ActionBar({ children, className }: ActionBarProps) {
  return <div className={twMerge('flex flex-col', className)}>{children}</div>;
}

ActionBar.Header = ActionBarHeader;
ActionBar.Content = ActionBarContent;

export { ActionBar };
